<div class="fixed-button active">
  <!-- <a href="https://codedthemes.com/item/gradient-able-angular-admin-template/" target="_blank" class="btn btn-md btn-primary has-ripple">
    <i aria-hidden="true" class="fa fa-shopping-cart"></i> Upgrade To Pro
  </a> -->
</div>
